import { useCallback } from 'react';
import { useInternalRegulationObligationRisksQuery } from '../graphql/queries/internalRegulationObligationRisks.generated';
import { createObligationIdFilter } from './filterConstants';

const PAGE_SIZE = 25;

export const useObligationRisks = (obligationId?: string) => {
  const { data, loading, error, fetchMore } = useInternalRegulationObligationRisksQuery({
    variables: {
      first: PAGE_SIZE,
      input: {
        filters: {
          groups: obligationId ? [createObligationIdFilter(obligationId)] : [],
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    skip: !obligationId,
  });

  const pageInfo = data?.internalRegulationObligationRisks?.pageInfo;

  const handleFetchMore = useCallback(() => {
    if (pageInfo?.hasNextPage && !loading) {
      fetchMore({
        variables: {
          after: pageInfo.endCursor,
        },
      });
    }
  }, [pageInfo, loading, fetchMore]);

  const risks = data?.internalRegulationObligationRisks?.edges.map((edge) => edge.node) ?? [];

  return { risks, loading, error, pageInfo, handleFetchMore };
};
